const tierCardCounts = {
    '1': 15,
    '2': 15,
    '3': 13,
    '4': 11,
    '5': 9,
    '6': 7,
    '7': 5,
}

const tavernCardCounts = {
    '1': 3,
    '2': 4,
    '3': 4,
    '4': 5,
    '5': 5,
    '6': 6,
    '7': 6,
}

export { tierCardCounts, tavernCardCounts };